import { darkTheme } from '../../theme/tokens';

const t = darkTheme;

export type BadgeTone = 'critical' | 'high' | 'medium' | 'low' | 'info' | 'success' | 'neutral';

// Severity-band colors live here (not in theme/tokens.ts) because they're
// semantic to findings — keeping the theme tokens generic. Shared by the Badge
// component and by callers that need a tone's color without a Badge box.
export const tonePresets: Record<BadgeTone, { bg: string; color: string }> = {
  critical: { bg: 'rgba(239,68,68,.15)', color: '#F87171' },
  high: { bg: 'rgba(245,158,11,.15)', color: '#FBBF24' },
  medium: { bg: 'rgba(250,204,21,.15)', color: '#FDE047' },
  low: { bg: 'rgba(106,136,153,.18)', color: '#A0B8C6' },
  info: { bg: t.blueBg, color: t.blueText },
  success: { bg: t.accentBg, color: t.accentText },
  neutral: { bg: t.surfaceAlt, color: t.text3 },
};

/** The foreground color for a tone — so callers can match a Badge without a Badge box. */
export function toneColor(tone: BadgeTone): string {
  return tonePresets[tone].color;
}

/** The (translucent) background for a tone — e.g. a cell tint matching a Badge. */
export function toneBg(tone: BadgeTone): string {
  return tonePresets[tone].bg;
}
